import React from "react";
import Alignment from "../MenuItems/Alignment";

const TextAlignment = ({ editor, disabled }) => {
	return (
		<>
			<div className={`editor-menu-box`}>
				<Alignment
					onClick={() => editor.chain().focus().setTextAlign("left").run()}
					isDisabled={
						disabled || editor.isActive("bulletList") || editor.isActive("orderedList")
					}
					isActive={editor.isActive({ textAlign: "left" })}
					isBulletList={editor.isActive("bulletList")}
					isOrderedList={editor.isActive("orderedList")}
					name="Left Align"
					icon="fa-align-left"
				/>
				<Alignment
					onClick={() => editor.chain().focus().setTextAlign("center").run()}
					isDisabled={
						disabled || editor.isActive("bulletList") || editor.isActive("orderedList")
					}
					isActive={editor.isActive({ textAlign: "center" })}
					isBulletList={editor.isActive("bulletList")}
					isOrderedList={editor.isActive("orderedList")}
					name="Center Align"
					icon="fa-align-center"
				/>
				<Alignment
					onClick={() => editor.chain().focus().setTextAlign("right").run()}
					isDisabled={
						disabled || editor.isActive("bulletList") || editor.isActive("orderedList")
					}
					isActive={editor.isActive({ textAlign: "right" })}
					isBulletList={editor.isActive("bulletList")}
					isOrderedList={editor.isActive("orderedList")}
					name="Right Align"
					icon="fa-align-right"
				/>
				<Alignment
					onClick={() => {
						if (editor.isActive({ textAlign: "justify" })) {
							editor.chain().focus().setTextAlign("left").run();
						} else {
							editor.chain().focus().setTextAlign("justify").run();
						}
					}}
					isDisabled={
						disabled || editor.isActive("bulletList") || editor.isActive("orderedList")
					}
					isActive={editor.isActive({ textAlign: "justify" })}
					name="Justify Content"
					icon="fa-align-justify"
				/>
			</div>
		</>
	);
};

export default TextAlignment;
